import Layout from '@layout/Index'

export const marketNg = [
  {
    path: '/market-ng',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "market-table" */ './pages/MarketNgTable.vue'),
        name: '门店异常列表',
        meta: {
          title: '门店异常列表',
        },
      },
      {
        path: 'detail/:marketId',
        component: () => import(/* webpackChunkName: "market-detail" */ './pages/MarketNgDetail.vue'),
        name: '门店异常详情',
        meta: {
          title: '门店异常详情',
        },
      }
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/market-ng/market-ng.route.js